// import React, { useState, useEffect, useCallback, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { CheckIcon, Trash2 } from 'lucide-react';
// import { useSelector, useDispatch } from 'react-redux';
// import StandardSpinner from '../../utils/Spinner';
// import { ACCOUNT_TYPE } from '../../utils/Account_Type';
// import TimeZoneSelect from '../Organization/Manager_Dashboard/utils/TimeZoneSelect';
// import timeZones from '../../assets/data/timeZone';
// import { useToast } from '../Toast';
// import useSocket from '../../hooks/useSocket';
// import { Get_Managers_User, Unenroll_User, Import_User_Template, Export_User_Template, Update_User, Delete_User, Set_Password, Create_User, Delete_User_Org, Update_User_Org, Enroll_User_Org, Enroll_User, Enroll_User_Mng, Delete_All_User, Enrolled_User } from '../../services/oprations/Users';

// // Custom Hooks
// import { useUserFilters } from '../../hooks/User/useUserFilters';
// import { useBulkOperations } from '../../hooks/User/useBulkOperations';
// import { useEnrollment } from '../../hooks/User/useEnrollment';
// import { useUserOperations } from '../../hooks/User/useUserOperations';
// import { useCSVImport } from '../../hooks/User/useCSVImport';

// // Components
// import UserStats from './components/UserStats';
// import SearchAndFilters from './components/SearchAndFilters';
// import UserTable from './components/UserTable';
// import UserCard from './components/UserCard';
// import BulkDeleteModal from './components/BulkDeleteModal';
// import EnrollDeviceModal from './components/EnrollDeviceModal';
// import ImportUserTemplate from './components/ImportUserTemplate';
// import EnrollPopup from './components/EnrollPopup';
// import CreateUserModal from './components/CreateUserModal';
// import ImportCSVModal from './components/ImportCSVModal';
// import UserDetailsModal from './components/UserDetailsModal';
// import SetPasswordModal from './components/SetPasswordModal';
// import DeleteConfirmModal from '../Notification/DeleteConfirmModal';
// import UpdateUserModal from './components/UpdateUserModal';

// // Helper Functions 
// const sortUsersAlphabetically = (usersArray) => {
//   if (!usersArray || !Array.isArray(usersArray)) return [];
//   return [...usersArray].sort((a, b) => {
//     const nameA = (a.user_name || '').toLowerCase();
//     const nameB = (b.user_name || '').toLowerCase();
//     return nameA.localeCompare(nameB);
//   });
// };

// const UserManagement = () => {
//   const toast = useToast();
//   const socket = useSocket();
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   // Redux State
//   const { users } = useSelector((state) => state.user);
//   const { managers } = useSelector((state) => state.manager);
//   const { devices } = useSelector((state) => state.device) || { devices: [] };
//   const { user } = useSelector((state) => state.profile);

//   // State
//   const [loading, setLoading] = useState(true);
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [liveSelectedUser, setLiveSelectedUser] = useState(null);
//   const [localUserOverrides, setLocalUserOverrides] = useState({});
//   const [confirmationModel, setConfirmationModel] = useState(null);
//   const [selectedDevice, setSelectedDevice] = useState(null);
//   const [deviceIdToDelete, setDeviceIdToDelete] = useState(null);
//   const [selectedEnrollmentId, setSelectedEnrollmentId] = useState(null);
//   const [userToDelete, setUserToDelete] = useState(null);

//   const [isEnrollUserToDeviceOpen, setIsEnrollUserToDeviceOpen] = useState(false);
//   const [isEnrollingToDevice, setIsEnrollingToDevice] = useState(false);
//   const [enrollToDeviceErrors, setEnrollToDeviceErrors] = useState({});
//   const [preselectedUserForEnroll, setPreselectedUserForEnroll] = useState(null);
//   const [isExportingTemplate, setIsExportingTemplate] = useState(false);
//   const [hasSubmitted, setHasSubmitted] = useState(false);

//   // Derived Data - MUST be defined before custom hooks that depend on them
//   const allusers = typeof users === 'string' ? JSON.parse(users) : users;
//   const userData = typeof user === 'string' ? JSON.parse(user) : user;
//   const token = localStorage.getItem('token');
//   const managersList = typeof managers === 'string' ? JSON.parse(managers) : (managers || []);
//   const devicesData = typeof devices === 'string' ? JSON.parse(devices) : (devices || []);

//   const mergedUsers = allusers?.map(u =>
//     localUserOverrides[u._id] ? { ...u, ...localUserOverrides[u._id] } : u
//   ).filter(u => !u._deleted) || [];

//   const sortedMergedUsers = sortUsersAlphabetically(mergedUsers);

//   const refreshUsers = useCallback(async () => {
//     await dispatch(Get_Managers_User());
//   }, [dispatch]);

//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit'
//     });
//   };

//   const getStatusBadge = (status) => status === 'ACTIVE'
//     ? 'bg-green-900/50 text-green-300 border border-green-700/50'
//     : 'bg-red-900/50 text-red-300 border border-red-700/50';

//   // Custom Hooks - Pass all required dependencies
//   const { searchTerm, setSearchTerm, filterStatus, setFilterStatus,
//     filterDepartment, setFilterDepartment, isFilterOpen, setIsFilterOpen,
//     filteredUsers, departments } = useUserFilters(sortedMergedUsers);

//   const { selectedIds, setSelectedIds, isBulkDeleteOpen, setIsBulkDeleteOpen,
//     isBulkDeleting, bulkProgress, toggleSelectAll, toggleSelectUser,
//     clearSelection, handleBulkDeleteConfirm, allFilteredSelected, someSelected } =
//     useBulkOperations(filteredUsers, dispatch, refreshUsers, toast, setLocalUserOverrides);

//   const { isEnrollModalOpen, setIsEnrollModalOpen, isEnrollPopupOpen, setIsEnrollPopupOpen,
//     enrollment, setEnrollment, enrollmentComplete, userToEnroll, setUserToEnroll,
//     selectedDeviceId, setSelectedDeviceId, availableDevices, enrollErrors,
//     isEnrolling, setIsEnrolling, handleEnrollClick, handleEnrollSubmit,
//     closeEnrollModal, handleCloseEnrollPopup, getEnrollmentStatusIcon,
//     getEnrollmentStatusColor, selectedDeviceObj, currentStepIndex,
//     stepStatus,
//     stepError,
//     waitingForSocket,
//     handleStartStep,
//     handleRetryStep,
//     handleGoToPreviousStep,
//     handleResetCurrentStep,
//     enrollmentStatus,
//     enrollmentMessage,
//     ENROLL_STEPS } =
//     useEnrollment(devicesData, allusers, dispatch, toast, refreshUsers, socket);

//   // User Operations with all required functions
//   const userOps = useUserOperations(dispatch, toast, refreshUsers, userData, managersList);
  
//   // Extract values from userOps
//   const {
//     isCreateModalOpen,
//     setIsCreateModalOpen,
//     isCreating,
//     createFormData,
//     handleCreateInputChange,
//     handleCreateSubmit,
//     handleCreateClick,
//     isUpdateModalOpen: opsIsUpdateModalOpen,
//     setIsUpdateModalOpen: opsSetIsUpdateModalOpen,
//     userToUpdate: opsUserToUpdate,
//     updateFormData: opsUpdateFormData,
//     handleUpdateInputChange,
//     handleUpdateSubmit,
//     handleUpdateClick,
//     closeUpdateModal,
//     isSetPasswordModalOpen,
//     setIsSetPasswordModalOpen,
//     userForPassword,
//     newPassword,
//     setNewPassword,
//     showPassword,
//     setShowPassword,
//     isSettingPassword,
//     handleSetPasswordClick,
//     handleSetPasswordSubmit,
//     closeSetPasswordModal,
//     handleDeleteConfirm: opsHandleDeleteConfirm
//   } = userOps;

//   // FIXED: Handle template enrollment
//   const handleEnrollUserToDevice = async (enrollmentData) => {
//     setIsEnrollingToDevice(true);
//     setEnrollToDeviceErrors({});
//     console.log("Import Form Data:", enrollmentData)

//     try {
//       const response = await dispatch(Import_User_Template({
//         userId: enrollmentData.userId,
//         deviceId: enrollmentData.deviceId,
//         thumbId: enrollmentData.templateId,
//         templateType: enrollmentData.templateType
//       }));

//       if (response?.data?.success || response?.data?.message) {
//         console.log("Success Api Call For Import");
//         toast.info('Enrollment request sent. Waiting for device response...');
//       } else {
//         throw new Error(response?.data?.message || 'Failed to enroll user');
//       }
//     } catch (error) {
//       console.error('Enrollment error:', error);
//       setEnrollToDeviceErrors({
//         general: error.message || 'Failed to enroll user to device. Please check if the fingerprint template exists.'
//       });
//       toast.error(error.message || 'Failed to enroll user');
//       setIsEnrollingToDevice(false);
//       setHasSubmitted(false); // Reset submission flag on error
//     }
//   };

//   // FIXED: Handle template button click with proper event handling
//   const handleEnrollToDeviceClick = (e, user) => {
//     // Stop propagation immediately
//     if (e) {
//       e.stopPropagation();
//       e.preventDefault();
//     }
    
//     console.log("Opening template enrollment modal for user:", user?.user_name);
//     setPreselectedUserForEnroll(user);
//     setIsEnrollUserToDeviceOpen(true);
//   };

//   // FIXED: Handle regular enroll click to prevent conflicts
//   const handleEnrollClickWrapper = (e, user) => {
//     if (e) {
//       e.stopPropagation();
//       e.preventDefault();
//     }
//     console.log("Opening regular enrollment for user:", user?.user_name);
//     handleEnrollClick(e, user);
//   };

//   // Handle export template
//   const handleExportTemplate = async (exportData) => {
//     console.log("Export Template Data:", exportData);
//     setIsExportingTemplate(true);

//     try {
//       const { userId, deviceId, fingerId } = exportData;

//       if (!userId || !deviceId || !fingerId) {
//         toast.error("Missing required data for template export");
//         return;
//       }

//       const response = await dispatch(Export_User_Template({
//         userId: userId,
//         deviceId: deviceId,
//         FingerId: fingerId
//       }));

//       if (response?.data?.success) {
//         toast.success("Fingerprint template exported successfully!");
//         console.log("Export response:", response.data);

//         if (response.data.data?.template) {
//           const templateData = response.data.data.template;
//           const blob = new Blob([JSON.stringify(templateData, null, 2)], { type: 'application/json' });
//           const url = URL.createObjectURL(blob);
//           const a = document.createElement('a');
//           a.href = url;
//           a.download = `fingerprint_template_user_${userId}_device_${deviceId}.json`;
//           document.body.appendChild(a);
//           a.click();
//           document.body.removeChild(a);
//           URL.revokeObjectURL(url);
//         }
//       } else {
//         throw new Error(response?.data?.message || 'Failed to export template');
//       }
//     } catch (error) {
//       console.error("Export template error:", error);
//       toast.error(error.message || 'Failed to export fingerprint template');
//     } finally {
//       setIsExportingTemplate(false);
//     }
//   };

//   // Use the values from custom hook
//   const isUpdateModalOpen = opsIsUpdateModalOpen;
//   const currentUserToUpdate = opsUserToUpdate;
//   const currentUpdateFormData = opsUpdateFormData;

//   const { isImportModalOpen, setIsImportModalOpen, csvFile, isImporting,
//     csvPreview, importErrors, importProgress, handleFileUpload,
//     handleImportSubmit, handleImportClick } =
//     useCSVImport(managersList, dispatch, toast, refreshUsers);
  
//   const handleDeleteConfirm = async () => {
//     if (userToDelete) {
//       const userId = userToDelete._id;
//       setLocalUserOverrides(prev => ({ ...prev, [userId]: { _deleted: true } }));
//       setConfirmationModel(null);

//       const success = await opsHandleDeleteConfirm(userToDelete);
//       if (success) {
//         setUserToDelete(null);
//       } else {
//         setLocalUserOverrides(prev => { const n = { ...prev }; delete n[userId]; return n; });
//       }
//     }
//   };

//   // Effects
//   useEffect(() => {
//     const init = async () => {
//       await refreshUsers();
//       setLoading(false);
//     };
//     init();
//   }, [refreshUsers]);

//   useEffect(() => {
//     if (Object.keys(localUserOverrides).length === 0) return;
//     setLocalUserOverrides(prev => {
//       const next = { ...prev };
//       let changed = false;
//       Object.keys(next).forEach(userId => {
//         const storeUser = allusers?.find(u => u._id === userId);
//         if (!storeUser) return;
//         const overrideDeviceCount = next[userId].devices?.length ?? null;
//         const storeDeviceCount = storeUser.devices?.length ?? null;
//         if (overrideDeviceCount !== null && storeDeviceCount === overrideDeviceCount) {
//           delete next[userId];
//           changed = true;
//         }
//       });
//       return changed ? next : prev;
//     });
//   }, [allusers]);

//   // Event Handlers
//   const handleUserClick = (user) => {
//     setSelectedUser(user);
//     setLiveSelectedUser(user);
//   };

//   const closeModal = () => {
//     setSelectedUser(null);
//     setLiveSelectedUser(null);
//   };

//   const handleUnenrollDevices = async () => {
//     if (!selectedUser) return;
//     const userId = selectedUser._id;
//     const originalDevices = selectedUser.devices;
//     setLiveSelectedUser(prev => prev ? { ...prev, devices: [] } : prev);
//     setLocalUserOverrides(prev => ({ ...prev, [userId]: { devices: [], enrollment_id: null } }));
//     setConfirmationModel(null);
//     const response = await dispatch(Unenroll_User(userId));
//     if (response?.data?.message) {
//       toast.success(response?.data?.message);
//       await refreshUsers();
//     } else {
//       setLiveSelectedUser(prev => prev ? { ...prev, devices: originalDevices } : prev);
//       setLocalUserOverrides(prev => { const n = { ...prev }; delete n[userId]; return n; });
//       toast.error(response?.data?.message);
//     }
//   };
  
//   const handleDeleteDevice = async () => {
//     if (!selectedUser) return;
//     const userId = selectedUser._id;
//     const devId = deviceIdToDelete;
//     const enrollmentId = selectedEnrollmentId;

//     console.log("Deleting device with:", { userId, devId, enrollmentId });

//     const originalDevices = liveSelectedUser?.devices || selectedUser.devices;
//     const updatedDevices = originalDevices.filter(d => d.device?._id !== devId && d.device !== devId);

//     setLiveSelectedUser(prev => prev ? { ...prev, devices: updatedDevices } : prev);
//     setLocalUserOverrides(prev => ({ ...prev, [userId]: { devices: updatedDevices } }));

//     setConfirmationModel(null);

//     const response = await dispatch(Unenroll_User(userId, devId, enrollmentId));

//     if (response?.data?.success || response?.data?.message) {
//       await refreshUsers();
//       setSelectedEnrollmentId(null);
//     } else {
//       setLiveSelectedUser(prev => prev ? { ...prev, devices: originalDevices } : prev);
//       setLocalUserOverrides(prev => { const n = { ...prev }; delete n[userId]; return n; });
//       toast.error(response?.data?.message || 'Failed to remove device');
//     }
//   };
  
//   const handlerClick = (user, device, activeTab, e, enrollmentId = null) => {
//     e && e.stopPropagation();
//     setConfirmationModel(activeTab);
//     if (device) {
//       console.log("Selected Device With FingerId:", device);
//       console.log("Selected Enrollment ID:", enrollmentId);
//       setSelectedDevice(device._id);
//       setDeviceIdToDelete(device._id);
//       setSelectedEnrollmentId(enrollmentId);
//     }
//     if (user) setUserToDelete(user);
//   };

//   if (loading) return <StandardSpinner />;

//   return (
//     <div className="flex flex-col h-full font-sans text-white bg-richblue-950">
//       <div className="flex-none p-3 sm:p-4 bg-richblue-950">
//         {/* Header */}
//         <div className="flex flex-wrap items-center justify-between gap-3 mb-3 sm:mb-5">
//           <div>
//             <h1 className="text-xl font-bold text-transparent sm:text-3xl bg-gradient-to-r from-blue-200 to-blue-400 bg-clip-text">
//               User Management
//             </h1>
//             <p className="mt-1 text-xs sm:text-sm text-blue-400/80">Manage all users and their permissions</p>
//           </div>
//         </div>
//         <UserStats users={sortedMergedUsers} />
//         <SearchAndFilters
//           searchTerm={searchTerm}
//           setSearchTerm={setSearchTerm}
//           filterStatus={filterStatus}
//           setFilterStatus={setFilterStatus}
//           filterDepartment={filterDepartment}
//           setFilterDepartment={setFilterDepartment}
//           isFilterOpen={isFilterOpen}
//           setIsFilterOpen={setIsFilterOpen}
//           departments={departments}
//           onImportClick={handleImportClick}
//           onCreateClick={handleCreateClick}
//         />
//       </div>

//       {someSelected && (
//         <div className="flex items-center justify-between gap-3 px-3 py-2.5 mx-3 sm:mx-4 mb-2 rounded-xl border border-red-700/50 bg-red-900/20">
//           <div className="flex items-center gap-2 text-sm text-red-300">
//             <CheckIcon className="w-4 h-4" />
//             <span className="font-medium">{selectedIds.length} user{selectedIds.length > 1 ? 's' : ''} selected</span>
//           </div>
//           <div className="flex items-center gap-2">
//             <button onClick={clearSelection} className="px-3 py-1.5 text-xs text-blue-100 border rounded-lg border-blue-400/80 hover:bg-blue-800/30 transition-colors">Clear</button>
//             <button onClick={() => setIsBulkDeleteOpen(true)} className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold text-white bg-red-600 rounded-lg hover:bg-red-500 transition-colors">
//               <Trash2 className="w-3.5 h-3.5" />Delete Selected
//             </button>
//           </div>
//         </div>
//       )}

//       <div className="flex-1 px-3 pb-4 sm:px-4">
//         {/* Desktop Table View */}
//         <div className="hidden border shadow-xl md:block bg-richblue-800/20 border-blue-700/80 rounded-xl shadow-blue-800/60">
//           <UserTable
//             users={filteredUsers}
//             selectedIds={selectedIds}
//             allFilteredSelected={allFilteredSelected}
//             onToggleSelectAll={toggleSelectAll}
//             onToggleSelectUser={toggleSelectUser}
//             onUserClick={handleUserClick}
//             onUpdateClick={handleUpdateClick}
//             onDeleteClick={handlerClick}
//             onEnrollClick={handleEnrollClickWrapper}
//             onSetPasswordClick={handleSetPasswordClick}
//             onEnrollToDeviceClick={handleEnrollToDeviceClick}
//             userRole={userData?.role}
//             getStatusBadge={getStatusBadge}
//           />
//         </div>

//         {/* Mobile Card View */}
//         <div className="space-y-3 md:hidden">
//           {filteredUsers.length > 0 && (
//             <div className="flex items-center justify-between px-1">
//               <label className="flex items-center gap-2 text-xs text-blue-300 cursor-pointer select-none" onClick={toggleSelectAll}>
//                 <input type="checkbox" checked={allFilteredSelected} onChange={toggleSelectAll}
//                   className="w-4 h-4 text-red-500 border-blue-700 rounded bg-richblue-900 focus:ring-red-600/50" />
//                 Select all ({filteredUsers.length})
//               </label>
//             </div>
//           )}
//           {filteredUsers.length > 0 ? filteredUsers.map((user) => (
//             <UserCard
//               key={user._id}
//               user={user}
//               isSelected={selectedIds.includes(user._id)}
//               onSelect={toggleSelectUser}
//               onClick={handleUserClick}
//               onUpdate={handleUpdateClick}
//               onDelete={handlerClick}
//               onEnroll={handleEnrollClickWrapper}
//               onSetPassword={handleSetPasswordClick}
//               onEnrollToDeviceClick={handleEnrollToDeviceClick}
//               userRole={userData?.role}
//               getStatusBadge={getStatusBadge}
//             />
//           )) : (
//             <div className="p-10 text-center border text-blue-400/60 border-blue-800/40 rounded-xl bg-richblue-800/10">
//               No users found matching your criteria
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Modals */}
//       <BulkDeleteModal
//         isOpen={isBulkDeleteOpen}
//         onClose={() => setIsBulkDeleteOpen(false)}
//         onConfirm={handleBulkDeleteConfirm}
//         selectedIds={selectedIds}
//         users={allusers}
//         isDeleting={isBulkDeleting}
//         progress={bulkProgress}
//       />

//       <EnrollDeviceModal
//         isOpen={isEnrollModalOpen}
//         onClose={closeEnrollModal}
//         onSubmit={handleEnrollSubmit}
//         user={userToEnroll}
//         devices={devicesData}
//         selectedDeviceId={selectedDeviceId}
//         setSelectedDeviceId={setSelectedDeviceId}
//         errors={enrollErrors}
//         isEnrolling={isEnrolling}
//       />
      
//       <EnrollPopup
//         isOpen={isEnrollPopupOpen}
//         onClose={handleCloseEnrollPopup}
//         enrollment={enrollment}
//         selectedDevice={selectedDeviceObj}
//         getEnrollmentStatusIcon={getEnrollmentStatusIcon}
//         getEnrollmentStatusColor={getEnrollmentStatusColor}
//         enrollmentStatus={enrollmentStatus}
//         enrollmentMessage={enrollmentMessage}
//         userToEnroll={userToEnroll}
//       />
      
//       <ImportUserTemplate
//         isOpen={isEnrollUserToDeviceOpen}
//         onClose={() => {
//           setIsEnrollUserToDeviceOpen(false);
//           setPreselectedUserForEnroll(null);
//           setEnrollToDeviceErrors({});
//           setIsEnrollingToDevice(false);
//           setHasSubmitted(false); // Reset the flag when modal closes
//         }}
//         users={sortedMergedUsers}
//         devices={devicesData}
//         onSubmit={handleEnrollUserToDevice}
//         isEnrolling={isEnrollingToDevice}
//         errors={enrollToDeviceErrors}
//         preselectedUser={preselectedUserForEnroll}
//         socket={socket}
//       />

//       <CreateUserModal
//         isOpen={isCreateModalOpen}
//         onClose={() => setIsCreateModalOpen(false)}
//         onSubmit={handleCreateSubmit}
//         formData={createFormData}
//         onInputChange={handleCreateInputChange}
//         managers={managersList}
//         userRole={userData?.role}
//         isCreating={isCreating}
//         timeZones={timeZones}
//       />

//       <ImportCSVModal
//         isOpen={isImportModalOpen}
//         onClose={() => setIsImportModalOpen(false)}
//         onImport={handleImportSubmit}
//         csvFile={csvFile}
//         onFileUpload={handleFileUpload}
//         isImporting={isImporting}
//         preview={csvPreview}
//         errors={importErrors}
//         progress={importProgress}
//       />

//       <UserDetailsModal
//         isOpen={!!(selectedUser && liveSelectedUser)}
//         onClose={closeModal}
//         user={liveSelectedUser}
//         onUnenrollAll={() => handlerClick(null, null, 'UnenrollAllDevice')}
//         onUnenrollDevice={(device, enrollmentId) => handlerClick(null, device, 'DeleteDevice', null, enrollmentId)}
//         onExportTemplate={handleExportTemplate}
//         formatDate={formatDate}
//         getStatusBadge={getStatusBadge}
//       />
      
//       <SetPasswordModal
//         isOpen={isSetPasswordModalOpen}
//         onClose={closeSetPasswordModal}
//         onSubmit={handleSetPasswordSubmit}
//         user={userForPassword}
//         password={newPassword}
//         setPassword={setNewPassword}
//         showPassword={showPassword}
//         setShowPassword={setShowPassword}
//         isSetting={isSettingPassword}
//       />

//       {/* Update User Modal */}
//       {isUpdateModalOpen && currentUserToUpdate && (
//         <UpdateUserModal
//           isOpen={isUpdateModalOpen}
//           user={currentUserToUpdate}
//           formData={currentUpdateFormData}
//           handleChange={handleUpdateInputChange}
//           handleSubmit={handleUpdateSubmit}
//           closeModal={closeUpdateModal}
//           loading={loading}
//           timeZones={timeZones}
//         />
//       )}

//       {/* Delete Confirmations */}
//       {confirmationModel === 'DeleteDevice' &&
//         <DeleteConfirmModal
//           isOpen={true}
//           onClose={() => setConfirmationModel(null)}
//           onConfirm={handleDeleteDevice}
//           title="Device"
//         />}
//       {confirmationModel === 'UnenrollAllDevice' &&
//         <DeleteConfirmModal
//           isOpen={true}
//           onClose={() => setConfirmationModel(null)}
//           onConfirm={handleUnenrollDevices}
//           title="Unenroll All Devices"
//         />}
//       {confirmationModel === 'DeleteUser' &&
//         <DeleteConfirmModal
//           isOpen={true}
//           onClose={() => setConfirmationModel(null)}
//           onConfirm={handleDeleteConfirm}
//           title="User"
//         />}
//     </div>
//   );
// };

// export default UserManagement;


import React, { useState, useEffect, useCallback } from 'react';
//import { useNavigate } from 'react-router-dom';
import { CheckIcon, Trash2 } from 'lucide-react';
import { useSelector, useDispatch } from 'react-redux';
import StandardSpinner from '../../utils/Spinner';
//import { ACCOUNT_TYPE } from '../../utils/Account_Type';
//import TimeZoneSelect from '../Organization/Manager_Dashboard/utils/TimeZoneSelect';
import timeZones from '../../assets/data/timeZone';
import { useToast } from '../Toast';
import useSocket from '../../hooks/useSocket';
import { useTheme } from '../../Context/themeContext';
import { Get_Managers_User, Unenroll_User, Import_User_Template, Export_User_Template } from '../../services/oprations/Users';

// Custom Hooks
import { useUserFilters } from '../../hooks/User/useUserFilters';
import { useBulkOperations } from '../../hooks/User/useBulkOperations';
import { useEnrollment } from '../../hooks/User/useEnrollment';
import { useUserOperations } from '../../hooks/User/useUserOperations';
import { useCSVImport } from '../../hooks/User/useCSVImport';

// Components
import UserStats from './components/UserStats';
import SearchAndFilters from './components/SearchAndFilters';
import UserTable from './components/UserTable';
import UserCard from './components/UserCard';
import BulkDeleteModal from './components/BulkDeleteModal';
import EnrollDeviceModal from './components/EnrollDeviceModal';
import ImportUserTemplate from './components/ImportUserTemplate';
import EnrollPopup from './components/EnrollPopup';
import CreateUserModal from './components/CreateUserModal';
import ImportCSVModal from './components/ImportCSVModal';
import UserDetailsModal from './components/UserDetailsModal';
import SetPasswordModal from './components/SetPasswordModal';
import DeleteConfirmModal from '../Notification/DeleteConfirmModal';
import UpdateUserModal from './components/UpdateUserModal';

// Helper Functions 
const sortUsersAlphabetically = (usersArray) => {
  if (!usersArray || !Array.isArray(usersArray)) return [];
  return [...usersArray].sort((a, b) => {
    const nameA = (a.user_name || '').toLowerCase();
    const nameB = (b.user_name || '').toLowerCase();
    return nameA.localeCompare(nameB);
  });
};

const UserManagement = () => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const toast = useToast();
  const socket = useSocket();
  const dispatch = useDispatch();
  //const navigate = useNavigate();

  // ─── Theme-aware classes ──────────────────────────────────────────────
  const bgPrimary = isDark ? 'bg-richblue-950' : 'bg-gray-50';
  //const bgCard = isDark ? 'bg-richblue-800/20' : 'bg-white/80';
  const bgTable = isDark ? 'bg-richblue-800/20' : 'bg-white';
  const bgSection = isDark ? 'bg-richblue-950' : 'bg-gray-50';
  
  const borderColor = isDark ? 'border-blue-700/80' : 'border-gray-300';
  //const borderLight = isDark ? 'border-blue-800/40' : 'border-gray-200';
  const borderRed = isDark ? 'border-red-700/50' : 'border-red-300';
  
  const textPrimary = isDark ? 'text-white' : 'text-gray-900';
  //const textSecondary = isDark ? 'text-blue-300' : 'text-gray-600';
  //const textMuted = isDark ? 'text-blue-400/80' : 'text-gray-500';
  
  const shadowColor = isDark ? 'shadow-blue-800/60' : 'shadow-gray-300';
  const bgRed = isDark ? 'bg-red-900/20' : 'bg-red-50';
  const textRed = isDark ? 'text-red-300' : 'text-red-700';

  // Redux State
  const { users } = useSelector((state) => state.user);
  const { managers } = useSelector((state) => state.manager);
  const { devices } = useSelector((state) => state.device) || { devices: [] };
  const { user } = useSelector((state) => state.profile);

  // State
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState(null);
  const [liveSelectedUser, setLiveSelectedUser] = useState(null);
  const [localUserOverrides, setLocalUserOverrides] = useState({});
  const [confirmationModel, setConfirmationModel] = useState(null);
  //const [selectedDevice, setSelectedDevice] = useState(null);
  const [deviceIdToDelete, setDeviceIdToDelete] = useState(null);
  const [selectedEnrollmentId, setSelectedEnrollmentId] = useState(null);
  const [userToDelete, setUserToDelete] = useState(null);

  const [isEnrollUserToDeviceOpen, setIsEnrollUserToDeviceOpen] = useState(false);
  const [isEnrollingToDevice, setIsEnrollingToDevice] = useState(false);
  const [enrollToDeviceErrors, setEnrollToDeviceErrors] = useState({});
  const [preselectedUserForEnroll, setPreselectedUserForEnroll] = useState(null);
  //const [isExportingTemplate, setIsExportingTemplate] = useState(false);
  //const [hasSubmitted, setHasSubmitted] = useState(false);

  // Derived Data
  const allusers = typeof users === 'string' ? JSON.parse(users) : users;
  const userData = typeof user === 'string' ? JSON.parse(user) : user;
  //const token = localStorage.getItem('token');
  const managersList = typeof managers === 'string' ? JSON.parse(managers) : (managers || []);
  const devicesData = typeof devices === 'string' ? JSON.parse(devices) : (devices || []);

  const mergedUsers = allusers?.map(u =>
    localUserOverrides[u._id] ? { ...u, ...localUserOverrides[u._id] } : u
  ).filter(u => !u._deleted) || [];

  const sortedMergedUsers = sortUsersAlphabetically(mergedUsers);

  const refreshUsers = useCallback(async () => {
    await dispatch(Get_Managers_User());
  }, [dispatch]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusBadge = (status) => {
    if (status === 'ACTIVE') {
      return isDark 
        ? 'bg-green-900/50 text-green-300 border border-green-700/50'
        : 'bg-green-100 text-green-700 border border-green-600';
    }
    return isDark
      ? 'bg-red-900/50 text-red-300 border border-red-700/50'
      : 'bg-red-100 text-red-700 border border-red-500';
  };

  // Custom Hooks
  const { searchTerm, setSearchTerm, filterStatus, setFilterStatus,
    filterDepartment, setFilterDepartment, isFilterOpen, setIsFilterOpen,
    filteredUsers, departments } = useUserFilters(sortedMergedUsers);

  const { selectedIds, setSelectedIds, isBulkDeleteOpen, setIsBulkDeleteOpen,
    isBulkDeleting, bulkProgress, toggleSelectAll, toggleSelectUser,
    clearSelection, handleBulkDeleteConfirm, allFilteredSelected, someSelected } =
    useBulkOperations(filteredUsers, dispatch, refreshUsers, toast, setLocalUserOverrides);

  const { isEnrollModalOpen, isEnrollPopupOpen,
    enrollment, userToEnroll,
    selectedDeviceId, setSelectedDeviceId, enrollErrors,
    isEnrolling, handleEnrollClick, handleEnrollSubmit,
    closeEnrollModal, handleCloseEnrollPopup, getEnrollmentStatusIcon,
    getEnrollmentStatusColor, selectedDeviceObj,
    enrollmentStatus,
    enrollmentMessage} =
    useEnrollment(devicesData, allusers, dispatch, toast, refreshUsers, socket);

  const userOps = useUserOperations(dispatch, toast, refreshUsers, userData, managersList);
  
  const {
    isCreateModalOpen,
    setIsCreateModalOpen,
    isCreating,
    createFormData,
    handleCreateInputChange,
    handleCreateSubmit,
    handleCreateClick,
    isUpdateModalOpen: opsIsUpdateModalOpen,
    //setIsUpdateModalOpen: opsSetIsUpdateModalOpen,
    userToUpdate: opsUserToUpdate,
    updateFormData: opsUpdateFormData,
    handleUpdateInputChange,
    handleUpdateSubmit,
    handleUpdateClick,
    closeUpdateModal,
    isSetPasswordModalOpen,
    //setIsSetPasswordModalOpen,
    userForPassword,
    newPassword,
    setNewPassword,
    showPassword,
    setShowPassword,
    isSettingPassword,
    handleSetPasswordClick,
    handleSetPasswordSubmit,
    closeSetPasswordModal,
    handleDeleteConfirm: opsHandleDeleteConfirm
  } = userOps;

  const handleEnrollUserToDevice = async (enrollmentData) => {
    setIsEnrollingToDevice(true);
    setEnrollToDeviceErrors({});
    console.log("Import Form Data:", enrollmentData)

    try {
      const response = await dispatch(Import_User_Template({
        userId: enrollmentData.userId,
        deviceId: enrollmentData.deviceId,
        thumbId: enrollmentData.templateId,
        templateType: enrollmentData.templateType
      }));

      if (response?.data?.success || response?.data?.message) {
        console.log("Success Api Call For Import");
        toast.info('Enrollment request sent. Waiting for device response...');
      } else {
        throw new Error(response?.data?.message || 'Failed to enroll user');
      }
    } catch (error) {
      console.error('Enrollment error:', error);
      setEnrollToDeviceErrors({
        general: error.message || 'Failed to enroll user to device. Please check if the fingerprint template exists.'
      });
      toast.error(error.message || 'Failed to enroll user');
      setIsEnrollingToDevice(false);
     // setHasSubmitted(false);
    }
  };

  const handleEnrollToDeviceClick = (e, user) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    console.log("Opening template enrollment modal for user:", user?.user_name);
    setPreselectedUserForEnroll(user);
    setIsEnrollUserToDeviceOpen(true);
  };

  const handleEnrollClickWrapper = (e, user) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    console.log("Opening regular enrollment for user:", user?.user_name);
    handleEnrollClick(e, user);
  };

  const handleExportTemplate = async (exportData) => {
    console.log("Export Template Data:", exportData);
    //setIsExportingTemplate(true);

    try {
      const { userId, deviceId, fingerId } = exportData;

      if (!userId || !deviceId || !fingerId) {
        toast.error("Missing required data for template export");
        return;
      }

      const response = await dispatch(Export_User_Template({
        userId: userId,
        deviceId: deviceId,
        FingerId: fingerId
      }));

      if (response?.data?.success) {
        toast.success("Fingerprint template exported successfully!");
        console.log("Export response:", response.data);

        if (response.data.data?.template) {
          const templateData = response.data.data.template;
          const blob = new Blob([JSON.stringify(templateData, null, 2)], { type: 'application/json' });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `fingerprint_template_user_${userId}_device_${deviceId}.json`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        }
      } else {
        throw new Error(response?.data?.message || 'Failed to export template');
      }
    } catch (error) {
      console.error("Export template error:", error);
      toast.error(error.message || 'Failed to export fingerprint template');
    } finally {
      //setIsExportingTemplate(false);
    }
  };

  const isUpdateModalOpen = opsIsUpdateModalOpen;
  const currentUserToUpdate = opsUserToUpdate;
  const currentUpdateFormData = opsUpdateFormData;

  const { isImportModalOpen, setIsImportModalOpen, csvFile, isImporting,
    csvPreview, importErrors, importProgress, handleFileUpload,
    handleImportSubmit, handleImportClick } =
    useCSVImport(managersList, dispatch, toast, refreshUsers);
  
  const handleDeleteConfirm = async () => {
    if (userToDelete) {
      const userId = userToDelete._id;
      setLocalUserOverrides(prev => ({ ...prev, [userId]: { _deleted: true } }));
      setConfirmationModel(null);

      const success = await opsHandleDeleteConfirm(userToDelete);
      if (success) {
        setUserToDelete(null);
      } else {
        setLocalUserOverrides(prev => { const n = { ...prev }; delete n[userId]; return n; });
      }
    }
  };

  // Effects
  useEffect(() => {
    const init = async () => {
      await refreshUsers();
      setLoading(false);
    };
    init();
  }, [refreshUsers]);

  useEffect(() => {
    if (Object.keys(localUserOverrides).length === 0) return;
    setLocalUserOverrides(prev => {
      const next = { ...prev };
      let changed = false;
      Object.keys(next).forEach(userId => {
        const storeUser = allusers?.find(u => u._id === userId);
        if (!storeUser) return;
        const overrideDeviceCount = next[userId].devices?.length ?? null;
        const storeDeviceCount = storeUser.devices?.length ?? null;
        if (overrideDeviceCount !== null && storeDeviceCount === overrideDeviceCount) {
          delete next[userId];
          changed = true;
        }
      });
      return changed ? next : prev;
    });
  }, [allusers, localUserOverrides]);

  // Event Handlers
  const handleUserClick = (user) => {
    setSelectedUser(user);
    setLiveSelectedUser(user);
  };

  const closeModal = () => {
    setSelectedUser(null);
    setLiveSelectedUser(null);
  };

  const handleUnenrollDevices = async () => {
    if (!selectedUser) return;
    const userId = selectedUser._id;
    const originalDevices = selectedUser.devices;
    setLiveSelectedUser(prev => prev ? { ...prev, devices: [] } : prev);
    setLocalUserOverrides(prev => ({ ...prev, [userId]: { devices: [], enrollment_id: null } }));
    setConfirmationModel(null);
    const response = await dispatch(Unenroll_User(userId));
    if (response?.data?.message) {
      toast.success(response?.data?.message);
      await refreshUsers();
    } else {
      setLiveSelectedUser(prev => prev ? { ...prev, devices: originalDevices } : prev);
      setLocalUserOverrides(prev => { const n = { ...prev }; delete n[userId]; return n; });
      toast.error(response?.data?.message);
    }
  };
  
  const handleDeleteDevice = async () => {
    if (!selectedUser) return;
    const userId = selectedUser._id;
    const devId = deviceIdToDelete;
    const enrollmentId = selectedEnrollmentId;

    console.log("Deleting device with:", { userId, devId, enrollmentId });

    const originalDevices = liveSelectedUser?.devices || selectedUser.devices;
    const updatedDevices = originalDevices.filter(d => d.device?._id !== devId && d.device !== devId);

    setLiveSelectedUser(prev => prev ? { ...prev, devices: updatedDevices } : prev);
    setLocalUserOverrides(prev => ({ ...prev, [userId]: { devices: updatedDevices } }));

    setConfirmationModel(null);

    const response = await dispatch(Unenroll_User(userId, devId, enrollmentId));

    if (response?.data?.success || response?.data?.message) {
      await refreshUsers();
      setSelectedEnrollmentId(null);
    } else {
      setLiveSelectedUser(prev => prev ? { ...prev, devices: originalDevices } : prev);
      setLocalUserOverrides(prev => { const n = { ...prev }; delete n[userId]; return n; });
      toast.error(response?.data?.message || 'Failed to remove device');
    }
  };
  
  const handlerClick = (user, device, activeTab, e, enrollmentId = null) => {
    e && e.stopPropagation();
    setConfirmationModel(activeTab);
    if (device) {
      console.log("Selected Device With FingerId:", device);
      console.log("Selected Enrollment ID:", enrollmentId);
      //setSelectedDevice(device._id);
      setDeviceIdToDelete(device._id);
      setSelectedEnrollmentId(enrollmentId);
    }
    if (user) setUserToDelete(user);
  };

  // Reuse the exact same selection + bulk-delete API used by the
  // checkbox -> "Delete Selected" flow, instead of the separate
  // single-user delete API.
  const handleRowDeleteClick = (user, device, activeTab, e) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    if (!user) return;
    setSelectedIds([user._id]);
    setIsBulkDeleteOpen(true);
  };

  if (loading) return <StandardSpinner />;

  return (
    <div className={`flex flex-col h-full font-sans ${textPrimary} ${bgPrimary} transition-colors duration-300`}>
      <div className={`flex-none p-3 sm:p-4 ${bgSection} transition-colors duration-300`}>
        {/* Header */}
        <div className="flex flex-wrap items-center justify-between gap-3 mb-3 sm:mb-5">
          <div>
            <h1 className={`text-xl font-bold text-transparent sm:text-3xl ${isDark ? 'bg-gradient-to-r from-blue-200 to-blue-400' : 'bg-gradient-to-r from-blue-600 to-blue-800'} bg-clip-text`}>
              User Management
            </h1>
            <p className={`mt-1 text-xs sm:text-sm ${isDark ? 'text-blue-400/80' : 'text-gray-500'}`}>Manage all users and their permissions</p>
          </div>
        </div>
        <UserStats users={sortedMergedUsers} />
        <SearchAndFilters
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          filterStatus={filterStatus}
          setFilterStatus={setFilterStatus}
          filterDepartment={filterDepartment}
          setFilterDepartment={setFilterDepartment}
          isFilterOpen={isFilterOpen}
          setIsFilterOpen={setIsFilterOpen}
          departments={departments}
          onImportClick={handleImportClick}
          onCreateClick={handleCreateClick}
          theme={theme}
        />
      </div>

      {someSelected && (
        <div className={`flex items-center justify-between gap-3 px-3 py-2.5 mx-3 sm:mx-4 mb-2 rounded-xl border ${borderRed} ${bgRed}`}>
          <div className={`flex items-center gap-2 text-sm ${textRed}`}>
            <CheckIcon className="w-4 h-4" />
            <span className="font-medium">{selectedIds.length} user{selectedIds.length > 1 ? 's' : ''} selected</span>
          </div>
          <div className="flex items-center gap-2">
            <button onClick={clearSelection} className={`px-3 py-1.5 text-xs ${isDark ? 'text-blue-100 border-blue-400/80 hover:bg-blue-800/30' : 'text-gray-700 border-gray-400 hover:bg-gray-200'} border rounded-lg transition-colors`}>
              Clear
            </button>
            <button onClick={() => setIsBulkDeleteOpen(true)} className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold text-white bg-red-600 rounded-lg hover:bg-red-500 transition-colors">
              <Trash2 className="w-3.5 h-3.5" />Delete Selected
            </button>
          </div>
        </div>
      )}

      <div className="flex-1 px-3 pb-4 sm:px-4">
        {/* Desktop Table View */}
        <div className={`hidden border shadow-xl md:block ${bgTable} ${borderColor} rounded-xl ${shadowColor} transition-colors duration-300`}>
          <UserTable
            users={filteredUsers}
            selectedIds={selectedIds}
            allFilteredSelected={allFilteredSelected}
            onToggleSelectAll={toggleSelectAll}
            onToggleSelectUser={toggleSelectUser}
            onUserClick={handleUserClick}
            onUpdateClick={handleUpdateClick}
            onDeleteClick={handleRowDeleteClick}
            onEnrollClick={handleEnrollClickWrapper}
            onSetPasswordClick={handleSetPasswordClick}
            onEnrollToDeviceClick={handleEnrollToDeviceClick}
            userRole={userData?.role}
            getStatusBadge={getStatusBadge}
            theme={theme}
          />
        </div>

        {/* Mobile Card View */}
        <div className="space-y-3 md:hidden">
          {filteredUsers.length > 0 && (
            <div className="flex items-center justify-between px-1">
              <label className={`flex items-center gap-2 text-xs cursor-pointer select-none ${isDark ? 'text-blue-300' : 'text-gray-700'}`} onClick={toggleSelectAll}>
                <input type="checkbox" checked={allFilteredSelected} onChange={toggleSelectAll}
                  className={`w-4 h-4 rounded ${isDark ? 'text-red-500 border-blue-700 bg-richblue-900 focus:ring-red-600/50' : 'text-red-500 border-gray-300 bg-white focus:ring-red-500'}`} />
                Select all ({filteredUsers.length})
              </label>
            </div>
          )}
          {filteredUsers.length > 0 ? filteredUsers.map((user) => (
            <UserCard
              key={user._id}
              user={user}
              isSelected={selectedIds.includes(user._id)}
              onSelect={toggleSelectUser}
              onClick={handleUserClick}
              onUpdate={handleUpdateClick}
              onDelete={handleRowDeleteClick}
              onEnroll={handleEnrollClickWrapper}
              onSetPassword={handleSetPasswordClick}
              onEnrollToDeviceClick={handleEnrollToDeviceClick}
              userRole={userData?.role}
              getStatusBadge={getStatusBadge}
              theme={theme}
            />
          )) : (
            <div className={`p-10 text-center border ${isDark ? 'text-blue-400/60 border-blue-800/40 bg-richblue-800/10' : 'text-gray-500 border-gray-200 bg-gray-100/10'} rounded-xl`}>
              No users found matching your criteria
            </div>
          )}
        </div>
      </div>

      {/* Modals - These sub-components will need to receive theme prop */}
      <BulkDeleteModal
        isOpen={isBulkDeleteOpen}
        onClose={() => setIsBulkDeleteOpen(false)}
        onConfirm={handleBulkDeleteConfirm}
        selectedIds={selectedIds}
        users={allusers}
        isDeleting={isBulkDeleting}
        progress={bulkProgress}
        theme={theme}
      />

      <EnrollDeviceModal
        isOpen={isEnrollModalOpen}
        onClose={closeEnrollModal}
        onSubmit={handleEnrollSubmit}
        user={userToEnroll}
        devices={devicesData}
        selectedDeviceId={selectedDeviceId}
        setSelectedDeviceId={setSelectedDeviceId}
        errors={enrollErrors}
        isEnrolling={isEnrolling}
        theme={theme}
      />
      
      <EnrollPopup
        isOpen={isEnrollPopupOpen}
        onClose={handleCloseEnrollPopup}
        enrollment={enrollment}
        selectedDevice={selectedDeviceObj}
        getEnrollmentStatusIcon={getEnrollmentStatusIcon}
        getEnrollmentStatusColor={getEnrollmentStatusColor}
        enrollmentStatus={enrollmentStatus}
        enrollmentMessage={enrollmentMessage}
        userToEnroll={userToEnroll}
        theme={theme}
      />
      
      <ImportUserTemplate
        isOpen={isEnrollUserToDeviceOpen}
        onClose={() => {
          setIsEnrollUserToDeviceOpen(false);
          setPreselectedUserForEnroll(null);
          setEnrollToDeviceErrors({});
          setIsEnrollingToDevice(false);
          //setHasSubmitted(false);
        }}
        users={sortedMergedUsers}
        devices={devicesData}
        onSubmit={handleEnrollUserToDevice}
        isEnrolling={isEnrollingToDevice}
        errors={enrollToDeviceErrors}
        preselectedUser={preselectedUserForEnroll}
        socket={socket}
        theme={theme}
      />

      <CreateUserModal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        onSubmit={handleCreateSubmit}
        formData={createFormData}
        onInputChange={handleCreateInputChange}
        managers={managersList}
        userRole={userData?.role}
        isCreating={isCreating}
        timeZones={timeZones}
        theme={theme}
      />

      <ImportCSVModal
        isOpen={isImportModalOpen}
        onClose={() => setIsImportModalOpen(false)}
        onImport={handleImportSubmit}
        csvFile={csvFile}
        onFileUpload={handleFileUpload}
        isImporting={isImporting}
        preview={csvPreview}
        errors={importErrors}
        progress={importProgress}
        theme={theme}
      />

      <UserDetailsModal
        isOpen={!!(selectedUser && liveSelectedUser)}
        onClose={closeModal}
        user={liveSelectedUser}
        onUnenrollAll={() => handlerClick(null, null, 'UnenrollAllDevice')}
        onUnenrollDevice={(device, enrollmentId) => handlerClick(null, device, 'DeleteDevice', null, enrollmentId)}
        onExportTemplate={handleExportTemplate}
        formatDate={formatDate}
        getStatusBadge={getStatusBadge}
        theme={theme}
      />
      
      <SetPasswordModal
        isOpen={isSetPasswordModalOpen}
        onClose={closeSetPasswordModal}
        onSubmit={handleSetPasswordSubmit}
        user={userForPassword}
        password={newPassword}
        setPassword={setNewPassword}
        showPassword={showPassword}
        setShowPassword={setShowPassword}
        isSetting={isSettingPassword}
        theme={theme}
      />

      {/* Update User Modal */}
      {isUpdateModalOpen && currentUserToUpdate && (
        <UpdateUserModal
          isOpen={isUpdateModalOpen}
          user={currentUserToUpdate}
          formData={currentUpdateFormData}
          handleChange={handleUpdateInputChange}
          handleSubmit={handleUpdateSubmit}
          closeModal={closeUpdateModal}
          loading={loading}
          timeZones={timeZones}
          theme={theme}
        />
      )}

      {/* Delete Confirmations */}
      {confirmationModel === 'DeleteDevice' &&
        <DeleteConfirmModal
          isOpen={true}
          onClose={() => setConfirmationModel(null)}
          onConfirm={handleDeleteDevice}
          title="Device"
          theme={theme}
        />}
      {confirmationModel === 'UnenrollAllDevice' &&
        <DeleteConfirmModal
          isOpen={true}
          onClose={() => setConfirmationModel(null)}
          onConfirm={handleUnenrollDevices}
          title="Unenroll All Devices"
          theme={theme}
        />}
      {confirmationModel === 'DeleteUser' &&
        <DeleteConfirmModal
          isOpen={true}
          onClose={() => setConfirmationModel(null)}
          onConfirm={handleDeleteConfirm}
          title="User"
          theme={theme}
        />}
    </div>
  );
};

export default UserManagement;
